import {create} from "zustand";

const useMainStore = create((set) => ({
    sessionUpdated: new Date().getTime(),
    setSessionUpdated: () => set({ sessionUpdated: new Date().getTime() }),
}));
export default useMainStore;